module.exports = __webpack_public_path__ + "img/logo_b.acf9200b.png";